// Composición de providers REAL de la app — única fuente del orden.
// La consumen main.tsx Y el smoke test de modales
// (src/test/components/modalProviderTree.test.tsx): un modal NiceModal se
// monta bajo este árbol exacto, así un bug de ORDEN de providers (p.ej.
// NiceModal fuera del Router → <Link> crashea con "Cannot destructure
// 'basename'") revienta en el test y no en producción.
import { AppProvider } from "@ctx/AppContext";
import { AuthProvider } from "@ctx/AuthContext";
import NiceModal from "@ebay/nice-modal-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@cl/queryClient";
import type { ReactNode } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { TooltipProvider } from "@ui/tooltip";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <AuthProvider>
          <TooltipProvider delayDuration={200}>
            <Router>
              {/* NiceModal DENTRO del Router: los modales montan bajo el
                  Provider y varios (UpgradeSheet) usan <Link>/useNavigate. */}
              <NiceModal.Provider>{children}</NiceModal.Provider>
            </Router>
          </TooltipProvider>
        </AuthProvider>
      </AppProvider>
    </QueryClientProvider>
  );
}
